<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <CDNFileManagerTable />
      </b-col>
    </b-row>
  </div>

</template>

<script>
  import CDNFileManagerTable from './CDNFileManagerTable.vue'

  export default {
    name: 'cdn-file-manager',
    components: {
      CDNFileManagerTable
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/cdnFileManager/CDNFileManager.vue